import gql from 'graphql-tag';

// Both updates run in one transaction, so the account never has two defaults (unique index).
export default gql`
  mutation setDefaultDesignProfile($groupId: Int!, $id: Int!) {
    previous: update_design_profiles(where: { group_id: { _eq: $groupId }, is_default: { _eq: true } }, _set: { is_default: false }) { affected_rows }
    next: update_design_profiles_by_pk(pk_columns: { profile_id: $id }, _set: { is_default: true }) { profile_id }
  }
`;
